import { AppChannel, Channel } from "@/config/channel"

const AppChannelsWithoutHeader: Channel[] = [
  AppChannel.ClientDesktopSisalPoker,
  AppChannel.AppSisalPoker,
  AppChannel.AppCasinoHub,
  AppChannel.AppMobileScommesse,
  AppChannel.AppCasinoSnai,
  AppChannel.AppLottery,
]

export { AppChannelsWithoutHeader }
